import { updateComposeLinkViewState } from '../actions/internalActions';
import getComposeLinkViewState from '../selectors/getComposeLinkViewState';
import { updateSharePointLinkUrl } from 'owa-link-data';
import { mutator } from 'satcheljs';

mutator(updateComposeLinkViewState, actionMessage => {
    const viewState = getComposeLinkViewState(actionMessage.linkId);
    viewState.displayName = actionMessage.displayName;
});

mutator(updateSharePointLinkUrl, actionMessage => {
    const viewState = getComposeLinkViewState(actionMessage.linkId);
    if (!viewState.isLinkBeautified && viewState.displayName === actionMessage.oldLinkUrl) {
        viewState.displayName = actionMessage.newLinkUrl;
    }
});
